module.exports = __webpack_public_path__ + "img/5.b5bd944b.svg";